import MicroModal from 'micromodal';

namespace NKU.Video {
	const youtubePrivacyEnhancedHost = 'https://www.youtube-nocookie.com/embed/';

	const getYouTubePlayerElement = (uniqueId: string) => {
		return document.getElementById(`youtube-player-${uniqueId}`);
	};

	const getYouTubeEmbedUrl = (videoId: string) => {
		const params = new URLSearchParams({
			autoplay: '1',
			controls: '1',
			rel: '0',
		});

		return `${youtubePrivacyEnhancedHost}${encodeURIComponent(videoId)}?${params.toString()}`;
	};

	const initYouTubePlayer = (videoId: string, uniqueId: string) => {
		const playerElement = getYouTubePlayerElement(uniqueId);
		if (!playerElement) return;

		const iframe = document.createElement('iframe');
		iframe.src = getYouTubeEmbedUrl(videoId);
		iframe.title = 'YouTube video player';
		iframe.className = 'w-100 h-100';
		iframe.allow =
			'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
		iframe.allowFullscreen = true;
		iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
		iframe.setAttribute('loading', 'lazy');
		iframe.style.border = '0';

		playerElement.replaceChildren(iframe);
	};

	const destroyYouTubePlayer = (uniqueId: string) => {
		getYouTubePlayerElement(uniqueId)?.replaceChildren();
	};

	const initVideo = (video: HTMLElement) => {
		video.addEventListener('click', (event: MouseEvent) => {
			event.preventDefault();

			// Get the data attributes from the clicked element
			const modalId = video.getAttribute('data-id');
			const youtubeId = video.getAttribute('data-youtubeid');

			// Extract the unique ID from the modal ID
			const uniqueId = modalId?.replace('modal-', '');
			if (!modalId || !youtubeId || !uniqueId) return;

			// Show the Micromodal with the specified ID
			MicroModal.show(modalId, {
				onClose: () => {
					destroyYouTubePlayer(uniqueId);
				},
			});

			// Initialize the YouTube player for the clicked video
			initYouTubePlayer(youtubeId, uniqueId);
		});
	};

	export const init = () => {
		setupVideoModule();
	};

	const setupVideoModule = () => {
		const videos = document.querySelectorAll('.js-video-modal');
		videos.forEach(initVideo);

		MicroModal.init();

		// Manually handle the modal close event
		document.addEventListener('micromodal:beforeClose', (event: Event) => {
			const modalId = (event.target as HTMLElement).id;
			const uniqueId = modalId.replace('modal-', '');

			// Destroy the YouTube player when the modal is closed
			destroyYouTubePlayer(uniqueId);
		});
	};
}

document.addEventListener('DOMContentLoaded', () => {
	NKU.Video.init();
});
